module.exports = __webpack_public_path__ + "img/pr-4.c250b8d4.png";